document.addEventListener("DOMContentLoaded",(function(){subscribe(PUB_SUB_EVENTS.cartUpdate,(function(t){"cart-items"===t.source?Debutify.cart=t.cartData:"product-form"===t.source&&(Debutify.settings.dbtfy_skip_cart?window.location.href="/checkout":fetch(`${routes.cart_url}.js`).then((t=>t.json())).then((t=>{Debutify.cart=t})).catch((t=>{console.error(t)})))}))}));
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('details').forEach((targetDetail) => {
    targetDetail.addEventListener('toggle', () => {
      if (targetDetail.open) {
        document.querySelectorAll('details').forEach((detail) => {
          if (detail !== targetDetail && detail.open) {
            detail.open = false;
          }
        });
      }
    });
  });
});
